export default {
    workerDeliveryFeeGroup: [],
    agencyShareInfoList: [],
};
